export default __webpack_public_path__ + "static/media/shield.befe6460.svg";